import {
  isSlackMessage,
  type ActionCardPreviewContent,
  type ActionCardProvider,
} from '@littlebird/action-cards';

import { Avatar } from '@/components/ui/Avatar';
import { cn } from '@/lib/utils';

import { providerIcon } from '../icons';

import { TeammateCardIcon } from './TeammateCardIcon';

export const ActionCardIcon = ({
  content,
  provider,
  className,
  showPerson = true,
}: {
  content: ActionCardPreviewContent;
  provider: ActionCardProvider;
  className?: string;
  showPerson?: boolean;
}) => {
  if (content.type === 'teammate_message') {
    return (
      <TeammateCardIcon teammate={content.teammate} className={className} />
    );
  }
  const person = showPerson
    ? (('person' in content ? content.person : undefined) ??
      (isSlackMessage(content)
        ? content.parent_message?.person
        : content.type === 'informational'
          ? content.source?.people.find((person) => person.avatar_url)
          : undefined))
    : undefined;
  const ProviderIcon = providerIcon[provider.id];
  // An informational card's source app is only a badge on the source person's
  // photo. Without a photo, or when it fails to load, the card is Littlebird's
  const isInformational = content.type === 'informational';
  const FallbackIcon = isInformational ? providerIcon.Littlebird : ProviderIcon;

  return (
    <span
      role="img"
      aria-label={isInformational ? 'Littlebird' : provider.label}
      className={cn(
        'group/card-icon relative block size-6 shrink-0',
        className
      )}
    >
      <Avatar
        avatarUrl={person?.avatar_url}
        alt=""
        imageClassName="action-card-photo size-full rounded-full object-cover"
        fallback={
          <span aria-hidden className="block size-full">
            <FallbackIcon className="size-full" />
          </span>
        }
      />
      <span
        aria-hidden
        data-card-icon-badge=""
        className="absolute -bottom-1 -right-1 hidden size-3.5 items-center justify-center rounded-full bg-surface ring-2 ring-surface group-has-[.action-card-photo]/card-icon:flex"
      >
        <ProviderIcon className="size-2.5" />
      </span>
    </span>
  );
};
